import { render, staticRenderFns } from "./SetupMcpPanel.vue?vue&type=template&id=7741f0ba"
import script from "./SetupMcpPanel.vue?vue&type=script&lang=js"
export * from "./SetupMcpPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports